import { FormikErrors } from "formik";

export interface Address {
  doorNo: string;
  street: string;
  city: string;
  state: string;
  pinCode: string;
}

export interface EmployeeDto {
  firstName: string;
  lastName: string;
  dateOfBirth: string | null;
  bloodGroup: string;
  fatherOrSpouseName: string;
  fatherName: string;
  motherName: string;
  personalContactNo: string;
  personalEmail: string;
  aadharNumber: string;
  panNumber: string;
  uanNumber: string;
  esiNumber: string;
  gender: string;
  isMarried: boolean;
  sameAsCurrentAddress: boolean;
  isWorkFromHome: boolean;
  presentAddress: Address;
  permanentAddress: Address;
  emergencyContactNo1: string;
  emergencyContactNo1Relationship: string;
  emergencyContactNo2: string;
  emergencyContactNo2Relationship: string;
  identificationMark?: string;
}

export interface EmployeeProfileEditProps {
  values: {
    employeeDto: EmployeeDto;
  };
  setFieldValue: (field: string, value: string | boolean | null | Address, shouldValidate?: boolean) => Promise<void | FormikErrors<{ employeeDto: EmployeeDto }>>;
  handleImageDelete: (file: File) => void;
  handleImageUpload: (file: File) => void;
  employeeImage: string | null;
  setFieldTouched: (field: string, isTouched?: boolean, shouldValidate?: boolean) => Promise<void | FormikErrors<{ employeeDto: EmployeeDto }>>;
}

export interface AddressInfo {
  doorNo?: string;
  street?: string;
  city?: string;
  state?: string;
  pinCode?: string;
  addressId?: string;
}

export interface DesignationInfo {
  designationId?: string;
  grade?: {
    name?: string;
  };
  designationInfo?: {
    name: string;
  };
}

export interface StatusInfo {
  statusId?: string;
}

export interface ManagerInfo {
  employeeId?: string;
}

export interface DepartmentInfo {
  departmentId?: string;
}

export interface EmployeeTypeInfo {
  employeeTypeId?: string;
}

export interface EmployeeAssertInfo {
  assertId?: string;
}

export interface EmployeeInfo {
  firstName?: string;
  lastName?: string;
  dateOfBirth?: string;
  bloodGroup?: string;
  fatherOrSpouseName?: string;
  fatherName?: string;
  motherName?: string;
  personalContactNo?: string;
  personalEmail?: string;
  aadharNumber?: string;
  panNumber?: string;
  uanNumber?: string;
  esiNumber?: string;
  gender?: string;
  isMarried?: boolean;
  sameAsCurrentAddress?: boolean | string;
  presentAddress?: AddressInfo;
  permanentAddress?: AddressInfo;
  emergencyContactNo1?: string;
  emergencyContactNo1Relationship?: string;
  emergencyContactNo2?: string;
  emergencyContactNo2Relationship?: string;
  isWorkFromHome?: boolean;
  identificationMark?: string;
  dateOfJoin?: string;
  nextProbationEndDate?: string;
  reportingManager?: ManagerInfo;
  initiationManager?: ManagerInfo;
  backGroundVerification?: string;
  designation?: DesignationInfo;
  status?: StatusInfo;
  department?: DepartmentInfo;
  employeeType?: EmployeeTypeInfo;
  officialEmail?: string;
  profileUrl?: string;
  employeeAssertInfo?: EmployeeAssertInfo;
}

export interface AddressDto {
  doorNo: string;
  street: string;
  city: string;
  state: string;
  pinCode: string;
  addressId: string;
}

export interface DesignationDto {
  designationId: string;
  grade?: string;
  designationName?: string;
}

export interface PreDesignationDto {
  preDesignationId: string;
}

export interface StatusDto {
  statusId: string;
}

export interface CompanyDto {
  dateOfJoin: string;
  designationEffectiveDate: string;
  nextProbationEndDate: string;
  reportingManagerId: string;
  initiatingManagerId: string;
  backGroundVerification: string;
  grade: string;
  designationDto: DesignationDto;
  preDesignationDto: PreDesignationDto;
  statusDto: StatusDto;
  departmentId: string;
  employeeTypeId: string;
  officialEmailId: string;
}

export interface EmployeeDtoProfile {
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  bloodGroup: string;
  fatherOrSpouseName: string;
  fatherName: string;
  motherName: string;
  personalContactNo: string;
  personalEmail: string;
}

export interface EmployeeDtoProof {
  aadharNumber: string;
  panNumber: string;
  uanNumber: string;
  esiNumber: string;
  gender: string;
  isMarried: boolean;
  sameAsCurrentAddress: string | boolean;
  presentAddress: AddressDto;
  permanentAddress: AddressDto;
  emergencyContactNo1: string;
  emergencyContactNo1Relationship: string;
  emergencyContactNo2: string;
  emergencyContactNo2Relationship: string;
  isWorkFromHome?: boolean;
  identificationMark?: string;
}

export interface InitialValues {
  employeeDto: EmployeeDtoProfile & EmployeeDtoProof;
  companyDto: CompanyDto;
  assertId: string | undefined;
}

// Runtime constants to ensure file has test coverage
export const DEFAULT_ADDRESS: Address = {
  doorNo: "",
  street: "",
  city: "",
  state: "",
  pinCode: "",
};

export const DEFAULT_DESIGNATION_INFO: DesignationInfo = {
  designationId: "",
  grade: { name: "" },
};

export const DEFAULT_MANAGER_INFO: ManagerInfo = {
  employeeId: "",
};

export const DEFAULT_EMPLOYEE_DTO_PROOF: EmployeeDtoProof = {
  aadharNumber: "",
  panNumber: "",
  uanNumber: "",
  esiNumber: "",
  gender: "M",
  isMarried: false,
  sameAsCurrentAddress: false,
  presentAddress: { ...DEFAULT_ADDRESS, addressId: "" },
  permanentAddress: { ...DEFAULT_ADDRESS, addressId: "" },
  emergencyContactNo1: "",
  emergencyContactNo1Relationship: "",
  emergencyContactNo2: "",
  emergencyContactNo2Relationship: "",
  isWorkFromHome: false,
  identificationMark: "",
};
